import React from 'react';
import Checkout from '../Checkout';
import Loading from '../../../../shared/Loading';
import useGetAgentSubscription from '../../../../Hooks/Agent/Getters/useGetAgentSubscription/useGetAgentSubscription';

/** @returns {JSX.Element} */
export default function SubscriptionIndex() {
	const { isGettingData } = useGetAgentSubscription();
	if (isGettingData) {
		return <Loading />;
	}
	return <Checkout />;
}
